import React, {useState, useEffect} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Panel} from "primereact/panel";
import {Sidebar} from "primereact/sidebar";
import {TabView, TabPanel} from 'primereact/tabview';
import {Button} from "primereact/button";
import {SplitButton} from 'primereact/splitbutton';


import SubstitutionFormComponent from '../../components/2.1/procurement/substitution/SubstitutionFormComponent';
import SubstitutionListComponent from '../../components/2.1/procurement/substitution/SubstitutionListComponent';
import PurhcaserequestListComponent
  from "../../components/2.1/procurement/purchaserequest/PurhcaserequestListComponent";
import PurchaserequestFormComponent
  from "../../components/2.1/procurement/purchaserequest/PurchaserequestFormComponent";
import PurchaserequestitemDndComponent
  from "../../components/2.1/procurement/purchaserequestitem/PurchaserequestitemDndComponent";
import PurhcaseorderListComponent from "../../components/2.1/procurement/purchaseorder/PurhcaseorderListComponent";
import PurchaseorderFormComponent from "../../components/2.1/procurement/purchaseorder/PurchaseorderFormComponent";
import PurchaseorderitemDndComponent
  from "../../components/2.1/procurement/purchaseorderitem/PurchaseorderitemDndComponent";
import MaterialListComponent from "../../components/2.1/inventory/material/MaterialListComponent";
import InventorygrnFormComponent from '../../components/2.1/inventory/inventory-grn/InventorygrnFormComponent';
import PurchaseorderShowComponent from "../../components/2.1/procurement/purchaseorder/PurchaseorderShowComponent";
import PurchaserequestShowComponent
  from "../../components/2.1/procurement/purchaserequest/PurchaserequestShowComponent";
import PurchaseorderitemListComponent
  from "../../components/2.1/procurement/purchaseorderitem/PurchaseorderitemListComponent";
import axios from "axios";
import EmployeeListComponent from '../../components/2.1/hr/empoloyee/EmployeeListComponent';
import ProjectListComponent from '../../components/2.1/project/ProjectListComponent';
import PurchaseorderInventorydocumentListComponent
  from "../../components/2.1/procurement/purchaseorder/PurchaseorderInventorydocumentListComponent";
import PurchaseorderInventorydocumentFormComponent
  from "../../components/2.1/procurement/purchaseorder/PurchaseorderInventorydocumentFormComponent";
import InventorygrnShowComponent from "../../components/2.1/inventory/inventory-grn/InventorygrnShowComponent";
import InventorydocumentShowComponent
  from "../../components/2.1/inventory/inventorydocument/InventorydocumentShowComponent";
import ProcurementDashboardComponent from "../../components/2.1/procurement/ProcurementDashboardComponent";
import ImportListComponent from "../../components/2.1/import/ImportListComponent";
import ImportFormComponent from "../../components/2.1/import/ImportFormComponent";
import PartnerListComponent from '../../components/2.1/partner/PartnerListComponent';
import PurchaseorderSupplierListComponent from '../../components/2.1/procurement/purchaseordersupplier/PurchaseorderSupplierListComponent';
import PurchaseorderSupplierFormComponent from '../../components/2.1/procurement/purchaseordersupplier/PurchaseorderSupplierFormComponent';
import PurchaseorderSupplierDndComponent from '../../components/2.1/procurement/purchaseordersupplier/PurchaseorderSupplierDndComponent';
import PurchaseorderInventorydocumentCopyListComponent from '../../components/2.1/procurement/purchaseorder/PurchaseorderInventorydocumentCopyListComponent';
import ReceiptShowComponent from '../../components/2.1/finance/receipt/ReceiptShowComponent';
import PurchaseorderInventorydocumentCopyDndComponent from '../../components/2.1/procurement/purchaseorder/PurchaseorderInventorydocumentCopyDndComponent';
import ReceiptRelationFulfillmentListComponent from '../../components/2.1/finance/receipt/ReceiptRelationFulfillmentListComponent';


export const InventoryPage = (props) => {

  const {t} = props;
  const history = useHistory();
  const {entity, action, id} = useParams();
  const [purchaseorder, setPurchaseorder] = useState({});
  const [statuses, setStatuses] = useState([]);
  const [loadingStatus, setLoadingStatus] = useState(false);
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const poStatus = String(purchaseorder.status || '').toUpperCase()
  const isEditablePurchaseOrder = !purchaseorder?.status || ['NEW', 'IN_PROGRESS'].includes(poStatus);
  const prStatus = String(window.App.state?.purchaserequestStatus || '').toUpperCase();
  const prItemCount = Number(window.App.state?.purchaserequestitemCount || 0);
  const [procurementDashboardId, setProcurementDashboardId] = useState(null);
  const canCreatePurchaseOrder = prStatus === 'DONE';
  const canClosePurchaserequest = prStatus === 'IN_PROGRESS' && prItemCount > 0;
  const [isOrderLoading, setIsOrderLoading] = useState(false);
  useEffect(() => {
    setIsOrderLoading(false);
  }, [entity, action, id]);
  const [purchaseOrderStatusDict, setPurchaseOrderStatusDict] = useState([]);
  const [purchaseOrder, setPurchaseOrder] = useState({});
  const [purchaseRequest, setPurchaseRequest] = useState({});
  const [costDetailsCollapsed, setCostDetailsCollapsed] = useState(true);
  const [costDetailsLoading, setCostDetailsLoading] = useState(false);
  const [costDetailsLoaded, setCostDetailsLoaded] = useState(false);
  const [costDetails, setCostDetails] = useState(null);

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  const getPurchaseOrderStatusLabel = (statusKey) => {
    const hit = Array.isArray(purchaseOrderStatusDict)
      ? purchaseOrderStatusDict.find(item => item.key === statusKey)
      : null;

    return hit?.value || statusKey;
  };

  const loadPurchaseOrderCostDetails = () => {
    if (!id || costDetailsLoading || costDetailsLoaded) return;

    setCostDetailsLoading(true);
    apiCall('get', `/api/v2/purchase-order/${id}/cost-details`)
      .then(response => {
        setCostDetails(response?.data?.data || {});
        setCostDetailsLoaded(true);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
      .finally(() => setCostDetailsLoading(false));
  };

  useEffect(() => {
    setCostDetailsCollapsed(true);
    setCostDetailsLoaded(false);
    setCostDetails(null);
  }, [id]);

  useEffect(() => {
    const current = String(purchaseorder.status || '').toUpperCase();
    const _statuses = [];
    if (current === 'NEW') {
      _statuses.push(
        { label: 'IN_PROGRESS' },
        { label: 'DELETED' },
      );
    } else if (current === 'IN_PROGRESS') {
      _statuses.push(
        { label: 'CLOSED' },
        { label: 'DELETED' },
      );
    }
    setStatuses(_statuses);
  }, [purchaseorder.status]);

  useEffect(() => {
    if ((entity === 'procurement'  && id && id !== 'undefined')) {
      apiCall('get', '/api/v2/procurement/' + id)
        .then(response => {
          const dId = response?.data?.data?.dashboard_id ?? response?.data?.data?.dashboard?.id ?? null;
          setProcurementDashboardId(dId);
        })
        .catch(() => {
          setProcurementDashboardId(null);
        })
    }
  }, [entity, id, window.App.state.rerenderProcurementShow])

  useEffect(() => {
    document.title = 'Beszerzés' + ' - ' + process.env.REACT_APP_TITLE;
    setTimeout(function () {
      if (document.getElementsByClassName('activeMenu')[0]) {
        document.getElementsByClassName('activeMenu')[0].classList.remove("activeMenu")
      }
      if (document.getElementsByClassName('procurement')[0]) {
        document.getElementsByClassName('procurement')[0].classList.add("activeMenu")
      }
    }, 1000)
    if (entity === 'purchase-order' && id) {
      apiCall('get', '/api/v2/purchase-order/' + id)
        .then(response => {
          setPurchaseorder(response.data.data)
          window.App.forceUpdate()
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
    }
  }, [window.App.state.rerenderProcurementPage, id]);

  useEffect(() => {
    apiCall('get', '/api/v2/dictionary/purchase-order-status')
      .then(response => {
        setPurchaseOrderStatusDict(response.data.data || []);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      });
  }, []);

  useEffect(() => {
    if ((window.App.state?.purchaserequestStatus === 'DONE') && activeTabIndex === 2) {
      setActiveTabIndex(1);
    }
  }, [window.App.state?.purchaserequestStatus, activeTabIndex]);

  return (
    <div className={"ProcurementPage"}>
      {localStorage.getItem('module_procurement') ? (
        <>
          {entity === 'dashboard' && (localStorage.getItem('roles') || '[]').includes('role_procurement_dashboard') &&
            <div className={"PageContent p-p-5 p-mx-auto"}>
              <ProcurementDashboardComponent />
            </div>
          }
          {entity === 'substitution' && (!action || action === 'update' || action === 'create') && localStorage.getItem('roles') && (localStorage.getItem('roles') || '[]').includes('role_purchase_substitution_read') &&
            <div className={"PageContent p-p-5 p-mx-auto"}>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                  <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                    {t('substitutionReasons')}
                  </h2>
                </div>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                  {localStorage.getItem('roles') && (localStorage.getItem('roles') || '[]').includes('role_purchase_substitution_write') && (
                    <a onClick={() => {
                      history.push('/procurement/substitution/create')
                    }}
                       className={"p-button  p-button-success p-ml-2"}>
                      <i className={"pi pi-plus"}></i>
                      &nbsp;
                      {t('addReason')}
                    </a>
                  )}
                </div>
              </div>
              <Panel>
                <SubstitutionListComponent backlink={'/procurement/substitution'}/>
              </Panel>
            </div>
          }
          {entity === 'substitution' && (action === 'create' || action === 'update') &&
            <Sidebar position="left"
                     showCloseIcon={false}
                     visible={action === 'create' || action === 'update'}
                     closeOnEscape={true}
                     style={{width: '780px'}}
                     onHide={() => {
                       if (action === 'create' || action === 'update') {
                         history.push('/procurement/substitution')
                       }
                     }}>
              <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {id ? t('reasonUpdate') : t('reasonCreate')}
                    </h2>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                    <a onClick={() => {
                      if (action === 'create' || action === 'update') {
                        history.push('/procurement/substitution')
                      }
                    }}
                       className={"p-button  p-button-secondary p-ml-2"}>
                      <i className={"pi pi-arrow-left"}></i>
                      &nbsp;
                      {t('back')}
                    </a>
                  </div>
                </div>
                <Panel>
                  {(action === 'create' || action === 'update') &&
                    <SubstitutionFormComponent backlink={'/procurement/substitution'}/>
                  }
                </Panel>
              </div>
            </Sidebar>
          }
          {entity === 'purchase-request' && (!action || action === 'create' || action === 'update') && localStorage.getItem('roles') && (localStorage.getItem('roles') || '[]').includes('role_purchase_order_req_write') &&
            <div className={"PageContent p-p-5 p-mx-auto"}>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                  <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                    {t('App\\Procurement\\Purchase-request')}
                  </h2>
                </div>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                  {(localStorage.getItem('roles') || '[]').includes('role_purchase_order_req_write') && (
                    <a onClick={() => {
                      // history.push('/procurement/purchase-request/create')
                      history.push('/procurement/purchase-request/create?create=purchaserequest&type=PROJECT&return=/procurement/purchase-request')
                    }}
                      className={"p-button  p-button-success p-ml-2"}>
                      <i className={"pi pi-plus"}></i>
                      &nbsp;
                      {t('addProjectPurchaseRequest')}
                    </a>
                  )}

                  {/*<a onClick={() => {
                    // history.push('/procurement/purchase-request/create')
                    history.push('/procurement/purchase-request/create?create=purchaserequest&type=INVENTORY&return=/procurement/purchase-request')
                  }}
                     className={"p-button  p-button-success p-ml-2"}>
                    <i className={"pi pi-plus"}></i>
                    &nbsp;
                    {t('addInventoryPurchaseRequest')}
                  </a>*/}
                </div>
              </div>
              <Panel>
                <PurhcaserequestListComponent backlink={'/procurement/purchase-request'}/>
              </Panel>
            </div>
          }
          {entity === 'purchase-request' && action === 'read' &&
            <div className={"PageContent p-p-5 p-mx-auto"}>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                  <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                    {purchaseRequest?.purchase_order_request_number}
                  </h2>
                </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                    <div className="p-d-inline-flex" style={{ gap: 8 }}>
                      <Button
                        icon="pi pi-shopping-cart"
                        className="p-button-success p-button-sm"
                        label={t('createPurchaseOrder')}
                        style={{ flex: '0 0 auto', whiteSpace: 'nowrap', maxWidth: 'none' }}
                        // disabled={window.App.state?.purchaserequestStatus !== 'DONE'}
                        loading={isOrderLoading}
                        disabled={!canCreatePurchaseOrder}
                        onClick={() => {
                          if (isOrderLoading) {
                            return;
                          }
                          setIsOrderLoading(true);
                          apiCall('post', '/api/v2/purchase-order-request/' + id + '/order')
                            .then(response => {
                              if (response?.data?.data?.id) {
                                history.push('/procurement/purchase-order/read/' + response?.data?.data?.id);
                              } else {
                                window.App.toastShow('error', t('error'));
                              }
                            })
                            .catch(error => {
                              window.App.toastShow('error', t('error'), error?.response?.data?.message || error.toString(), '', error.response);
                            })
                            .finally(() => setIsOrderLoading(false));
                        }}
                      />
                      <Button
                        icon="pi pi-lock"
                        className="p-button-warning p-button-sm"
                        label={t('closePurchaseRequest')}
                        style={{ flex: '0 0 auto', whiteSpace: 'nowrap', maxWidth: 'none' }}
                        // disabled={window.App.state?.purchaserequestStatus === 'DONE'}
                        disabled={!canClosePurchaserequest}
                        onClick={() => {
                          apiCall('post', '/api/v2/purchase-order-request/' + id + '/complete')
                            .then(() => {
                              window.App.toastShow('success', 'Sikeres mentés!');
                              window.App.setState({
                                rerenderPurchaserequestList: Math.random(),
                                rerenderPurchaserequestShow: Math.random(),
                                purchaserequestStatus: 'DONE',
                              });
                              setActiveTabIndex(1);
                            })
                            .catch(error => {
                              window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                            });
                        }}
                      />
                      <a
                        onClick={() => {
                          history.push('/procurement/purchase-request')
                        }}
                        className={"p-button  p-button-secondary p-ml-2"}
                      >
                        <i className={"pi pi-arrow-left"}></i>
                        &nbsp;
                        {t('back')}
                      </a>
                    </div>
                  </div>
              </div>
              <Panel>
                <TabView className="tabview-header-icon menu" style={{border: 'none'}} activeIndex={activeTabIndex} onTabChange={(e) => setActiveTabIndex(e.index)}>
                  <TabPanel header={t('tabBasicData')} leftIcon="pi pi-list">
                    <div className={"p-grid"}>
                      <div className={"p-col"}>
                        <div className={"p-grid"}>
                          <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                            <h3 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                              {t('fieldName')}
                            </h3>
                          </div>
                          <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right">
                            <div className="p-d-flex" style={{gap: 8, flexWrap: 'nowrap'}}>
                              <Button
                                icon="pi pi-pencil"
                                className="p-button-warning p-button-sm"
                                label={t('editAction')}
                                style={{flex: '0 0 auto', whiteSpace: 'nowrap', maxWidth: 'none'}}
                                disabled={window.App.state?.purchaserequestStatus === 'DONE' || window.App.state?.purchaserequestStatus === 'ORDERED'}
                                tooltipOptions={{position: 'left'}}
                                onClick={() => {
                                  history.push(
                                    '/procurement/purchase-request/read/' +
                                    id +
                                    '&update=purchaserequest&return=/procurement/purchase-request/read/' +
                                    id
                                  );
                                }}
                              />

                              {/* <Button
                                icon="pi pi-lock"
                                className="p-button-warning p-button-sm"
                                label={t('closePurchaseRequest')}
                                style={{flex: '0 0 auto', whiteSpace: 'nowrap', maxWidth: 'none'}}
                                disabled={window.App.state?.purchaserequestStatus === 'DONE'}
                                onClick={() => {
                                  apiCall('patch', '/api/v2/purchase-order-request/' + id, {status: 'DONE'})
                                    .then(() => {
                                      window.App.toastShow('success', 'Sikeres mentés!');
                                      window.App.setState({
                                        rerenderPurchaserequestList: Math.random(),
                                        rerenderPurchaserequestShow: Math.random(),
                                        purchaserequestStatus: 'DONE',
                                      });
                                    })
                                    .catch(error => {
                                      window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                                    });
                                }}
                              /> */}
                            </div>
                          </div>
                        </div>
                        <PurchaserequestShowComponent onLoaded={(purchaseRequest) => setPurchaseRequest(purchaseRequest || {})}/>
                      </div>
                      <div className={"p-col-8"}>
                        <div className={"p-grid"}>
                          <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                            <h3 className={"p-m-0 p-p-0 text-primary p-d-inline"}>

                            </h3>
                          </div>
                          <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>

                          </div>
                        </div>
                        {/* {purchaseorder && purchaseorder.dashboard &&
                          <ProcurementDashboardComponent summary={purchaseorder.dashboard}/>
                        } */}
                      </div>
                    </div>
                  </TabPanel>
                  <TabPanel header={t('tabItems')} leftIcon="pi pi-list">
                    <PurchaserequestitemDndComponent/>
                  </TabPanel>
                  {window.App.state?.purchaserequestStatus !== 'DONE' && window.App.state?.purchaserequestStatus !== 'ORDERED' && (
                    <TabPanel header={t('tabImport')} leftIcon="pi pi-list">
                      <div className={"p-grid"}>
                        <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                          <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                            {t('importProcesses')}
                          </h2>
                        </div>
                        <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                    <span className={"p-mr-2"}>

                    </span>
                          <a onClick={() => {
                            history.push('/procurement/purchase-request/read/' + id +  '?create=import')
                          }}
                            className={"p-button  p-button-success p-ml-2"}>
                            <i className={"pi pi-plus"}></i>
                            &nbsp;
                            {t('addImport')}
                          </a>
                        </div>
                      </div>
                      <ImportListComponent />
                    </TabPanel>
                  )}
                </TabView>
              </Panel>
            </div>
          }
          {entity === 'purchase-request' && (action === 'create' || action === 'update' || window.App.urlVars().update === 'purchaserequest' || window.App.urlVars().create === 'purchaserequest') &&
            <Sidebar position="left"
                     showCloseIcon={false}
                     visible={action === 'create' || action === 'update' || window.App.urlVars().update === 'purchaserequest' || window.App.urlVars().create === 'purchaserequest'}
                     closeOnEscape={true}
                     style={{width: '780px'}}
                     onHide={() => {
                       history.push(window.App.urlVars().return)
                     }}>
              <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {id && id !== 'undefined' ? t('purchaseRequestUpdate') : t('purchaseRequestCreate')}
                    </h2>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                    <a onClick={() => {
                      // history.push(window.App.urlVars().return)
                      history.push('/procurement/purchase-request')
                    }}
                       className={"p-button  p-button-secondary p-ml-2"}>
                      <i className={"pi pi-arrow-left"}></i>
                      &nbsp;
                      {t('back')}
                    </a>
                  </div>
                </div>
                <Panel>
                  <PurchaserequestFormComponent/>
                </Panel>
              </div>
            </Sidebar>
          }
          {entity === 'purchase-order' && (!action || action === 'create' || action === 'update') && localStorage.getItem('roles') && (localStorage.getItem('roles') || '[]').includes('role_purchase_order_write') &&
            <div className={"PageContent p-p-5 p-mx-auto"}>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                  <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                    {t('App\\Procurement\\Purchase-order')}
                  </h2>
                </div>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                  {localStorage.getItem('roles') && (localStorage.getItem('roles') || '[]').includes('role_purchase_order_write') && (
                    <a onClick={() => {
                      history.push('/procurement/purchase-order/create?return=/procurement/purchase-order')
                    }}
                       className={"p-button  p-button-success p-ml-2"}>
                      <i className={"pi pi-plus"}></i>
                      &nbsp;
                      {t('addPurchaseOrder')}
                    </a>
                  )}
                </div>
              </div>
              <Panel>
                <PurhcaseorderListComponent backlink={'/procurement/purchase-order'}/>
              </Panel>
            </div>
          }
          {entity === 'purchase-order' && action === 'read' &&
            <div className={"PageContent p-p-5 p-mx-auto"}>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                  <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                    {purchaseOrder?.purchase_order_number} - {purchaseOrder?.project?.name}
                  </h2>
                </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                    <div className="p-d-inline-flex" style={{ gap: 8 }}>
                      {id && id !== 'undefined' && purchaseorder.status && (
                        <SplitButton
                          label={getPurchaseOrderStatusLabel(purchaseorder.status)}
                          id="buttonStatus"
                          type="button"
                          loading={loadingStatus}
                          disabled={!id || !isEditablePurchaseOrder || statuses.length === 0}
                          onClick={() => {
                            document
                              .getElementById('buttonStatus')
                              ?.getElementsByClassName('p-splitbutton-menubutton')?.[0]
                              ?.click();
                          }}
                          icon="pi pi-info-circle"
                          className="p-button-warning p-button-sm"
                          model={statuses.map(status => ({
                            label: getPurchaseOrderStatusLabel(status.label),
                            command: () => {
                              setLoadingStatus(true);
                              apiCall('patch', '/api/v2/purchase-order/' + id + "/status", { status: status.label })
                                .then(response => {
                                  window.App.toastShow('success', 'Sikeres módosítás', response.data.message);
                                  setPurchaseorder(response.data.data);
                                  window.App.setState?.({ rerenderPurchaseorderShow: Math.random() });
                                })
                                .catch(error => {
                                  window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                                })
                                .finally(() => setLoadingStatus(false));
                            }
                          }))}
                        />
                      )}
                      <a
                        onClick={() => {
                          history.push('/procurement/purchase-order')
                        }}
                        className={"p-button  p-button-secondary p-ml-2"}
                      >
                        <i className={"pi pi-arrow-left"}></i>
                        &nbsp;
                        {t('back')}
                      </a>
                    </div>
                  </div>
              </div>
              <Panel>
                <TabView renderActiveOnly="true" className="tabview-header-icon menu" style={{border: 'none'}}>
                  <TabPanel header={t('tabBasicData')} leftIcon="pi pi-list">
                    <div className={"p-grid"}>
                      <div className={"p-col"}>
                        <div className={"p-grid"}>
                          <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                            <h3 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                              {t('fieldName')}
                            </h3>
                          </div>
                          <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                            <div className="p-d-inline-flex" style={{gap: 8}}>
                              <Button icon="pi pi-pencil" className="p-button-warning p-button-sm p-ml-2"
                                      label={t('editAction')} tooltipOptions={{position: 'left'}}
                                      disabled={!id || !isEditablePurchaseOrder}
                                      onClick={() => {
                                        history.push('/procurement/purchase-order/read/' + id + '&update=purchaseorder&return=/procurement/purchase-order/read/' + id)
                                      }}/>
                              {/* {id && id !== 'undefined' && purchaseorder.status && (
                                <SplitButton
                                  label={t(purchaseorder.status.toLowerCase())}
                                  id="buttonStatus"
                                  type="button"
                                  loading={loadingStatus}
                                  disabled={!id || purchaseorder.status === 'CLOSED'}
                                  onClick={() => {
                                    document
                                      .getElementById('buttonStatus')
                                      ?.getElementsByClassName('p-splitbutton-menubutton')?.[0]
                                      ?.click();
                                  }}
                                  icon="pi pi-info-circle"
                                  className="p-button-warning p-button-sm"
                                  model={statuses.map(status => ({
                                    label: t(status.label.toLowerCase()),
                                    command: () => {
                                      setLoadingStatus(true);
                                      apiCall('patch', '/api/v2/purchase-order/' + id + "/status", {status: status.label})
                                        .then(response => {
                                          window.App.toastShow('success', 'Sikeres módosítás', response.data.message);
                                          setPurchaseorder(response.data.data);
                                          window.App.setState?.({rerenderPurchaseorderShow: Math.random()});
                                        })
                                        .catch(error => {
                                          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                                        })
                                        .finally(() => setLoadingStatus(false));
                                    }
                                  }))}
                                />
                              )} */}
                            </div>
                          </div>
                        </div>
                        <PurchaseorderShowComponent onLoaded={(purchaseOrder) => setPurchaseOrder(purchaseOrder || {})} />
                        <div className="p-mt-2">
                          <Button
                            type="button"
                            label={t('additionalDetails')}
                            icon={costDetailsCollapsed ? 'pi pi-chevron-right' : 'pi pi-chevron-down'}
                            className="p-button-text p-button-secondary p-button-sm p-px-0"
                            style={{background: 'transparent', boxShadow: 'none', fontWeight: 400}}
                            onClick={() => {
                              const willOpen = costDetailsCollapsed;
                              setCostDetailsCollapsed(!costDetailsCollapsed);
                              if (willOpen) loadPurchaseOrderCostDetails();
                            }}
                          />
                          {!costDetailsCollapsed && (costDetailsLoading ? (
                            <div className="p-text-center p-p-3">{t('loading')}</div>
                          ) : (
                            <div className="p-grid">
                              <div className="p-col-12 p-md-4">
                                <div style={{background: 'var(--surface-50)', borderRadius: 6, padding: '1rem', height: '100%'}}>
                                  <div style={{fontSize: '0.75rem', color: 'var(--text-color-secondary)', marginBottom: '0.5rem'}}>
                                    {t('targetWarehouseType')}
                                  </div>
                                  <strong className="p-d-block">
                                    {costDetails?.warehouse_type_label || costDetails?.warehouse_type || t('notConfigured')}
                                  </strong>
                                </div>
                              </div>
                              <div className="p-col-12 p-md-4">
                                <div style={{background: 'var(--surface-50)', borderRadius: 6, padding: '1rem', height: '100%'}}>
                                  <div style={{fontSize: '0.75rem', color: 'var(--text-color-secondary)', marginBottom: '0.5rem'}}>
                                    {t('projectCostCenter')}
                                  </div>
                                  <strong className="p-d-block">
                                    {costDetails?.cost_center
                                      ? `${costDetails.cost_center.name} (${costDetails.cost_center.code})`
                                      : t('notConfigured')}
                                  </strong>
                                </div>
                              </div>
                              <div className="p-col-12 p-md-4">
                                <div style={{background: 'var(--surface-50)', borderRadius: 6, padding: '1rem', height: '100%'}}>
                                  <div style={{fontSize: '0.75rem', color: 'var(--text-color-secondary)', marginBottom: '0.5rem'}}>
                                    {t('defaultProcurementCostType')}
                                  </div>
                                  <strong className="p-d-block">
                                    {costDetails?.cost_type
                                      ? `${costDetails.cost_type.name} (${costDetails.cost_type.acronym})`
                                      : t('notConfigured')}
                                  </strong>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                      <div className={"p-col-8"}>
                        <div className={"p-grid"}>
                          <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                            <h3 className={"p-m-0 p-p-0 text-primary p-d-inline"}>

                            </h3>
                          </div>
                          <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>

                          </div>
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                  <TabPanel header={t('tabItems')} leftIcon="pi pi-list">
                    <PurchaseorderitemDndComponent/>
                  </TabPanel>
                  {/* <TabPanel header="Ajánlatkérés" leftIcon="pi pi-list">
                    <div className={"p-grid"}>
                      <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                        <h3 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                          {t('productionProjectItem')}
                        </h3>
                      </div>
                      <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                        <a onClick={() => {
                          //
                        }}
                           className={"p-button p-button-sm p-button-success p-ml-2"}>
                          <i className={"pi pi-download"}></i>
                          &nbsp;
                          Letöltés
                        </a>
                      </div>
                    </div>
                    <PurchaseorderitemListComponent/>
                  </TabPanel> */}
                  <TabPanel header={t('tabAssembly')} leftIcon="pi pi-list">
                    <PurchaseorderitemListComponent mode={'order'}/>
                  </TabPanel>
                  <TabPanel header={t('tabOrder')} leftIcon="pi pi-list">
                    <div className="p-grid">
                      <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left">
                        <h3 className="p-m-0 p-p-0 text-primary p-d-inline">
                          {t('supplierOrders')}
                        </h3>
                      </div>
                      <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right">
                        {isEditablePurchaseOrder && (
                          <a
                            onClick={() => {
                              history.push(
                                '/procurement/' + entity + '/' + action + '/' + id + '?create=purchaseorder-supplier'
                              );
                            }}
                            className="p-button p-button-sm p-button-success p-ml-2"
                          >
                            <i className="pi pi-plus" />
                            &nbsp;
                            {t('addSupplierOrder')}
                          </a>
                        )}
                      </div>
                    </div>
                    <Panel>
                      <PurchaseorderSupplierListComponent purchaseOrderStatus={purchaseorder.status} />
                    </Panel>
                  </TabPanel>
                  <TabPanel header={t('tabDeliveryNote')} leftIcon="pi pi-list">
                    <div className={"p-grid"}>
                      <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                        <h3 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                          {t('deliveryNotes')}
                        </h3>
                      </div>
                      <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                        {/* {purchaseorder.status !== 'CLOSED' && (
                          <a onClick={() => {
                            history.push('/procurement/' + entity + '/' + action + '/' + id + '?create=inventorydocument&type=transfer-supplier')
                          }}
                            className={"p-button p-button-sm p-button-success p-ml-2"}>
                            <i className={"pi pi-plus"}></i>
                            &nbsp;
                            {t('deliveryNoteRegistration')}
                          </a>
                        )} */}
                      </div>
                    </div>
                    <Panel>
                      {/*<InventorydocumentListComponent entity={'transfer-supplier'} type={'TRANSFER_SUPPLIER'}/>*/}
                      <PurchaseorderInventorydocumentListComponent entity={'transfer-supplier'}
                                                                   type={'TRANSFER_SUPPLIER'}/>
                    </Panel>
                  </TabPanel>
                  <TabPanel header={t('tabInvoices')} leftIcon="pi pi-file">
                    <ReceiptRelationFulfillmentListComponent view="procurement" purchaseOrderId={id} />
                  </TabPanel>
                  {/* <TabPanel header="Bevételezés" leftIcon="pi pi-list">
                    <div className={"p-grid"}>
                      <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                        <h3 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                          {t('goodsReceiptList')}
                        </h3>
                      </div>
                      <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                      </div>
                    </div>
                    <Panel>
                      <InventoryGrnListComponent purchaseOrderId={id} standalone={true}/>
                    </Panel>
                  </TabPanel> */}
                  <TabPanel header={t('tabReport')} leftIcon="pi pi-chart-bar">
                    <ProcurementDashboardComponent key={procurementDashboardId} dashboardId={procurementDashboardId} />
                  </TabPanel>
                </TabView>
              </Panel>
            </div>
          }
          {entity === 'purchase-order' && (action === 'create' || action === 'update' || window.App.urlVars().update === 'purchaseorder' || window.App.urlVars().create === 'purchaseorder') &&
            <Sidebar position="left"
                     showCloseIcon={false}
                     visible={action === 'create' || action === 'update' || window.App.urlVars().update === 'purchaseorder' || window.App.urlVars().create === 'purchaseorder'}
                     closeOnEscape={true}
                     style={{width: '780px'}}
                     onHide={() => {
                       history.push(window.App.urlVars().return)
                     }}>
              <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {id && id !== 'undefined' ? t('purchaseOrderUpdate') : t('purchaseOrderCreate')}
                    </h2>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                    <a onClick={() => {
                      // history.push(window.App.urlVars().return)
                      history.push('/procurement/purchase-order')
                    }}
                       className={"p-button  p-button-secondary p-ml-2"}>
                      <i className={"pi pi-arrow-left"}></i>
                      &nbsp;
                      {t('back')}
                    </a>
                  </div>
                </div>
                <Panel>
                  <PurchaseorderFormComponent/>
                </Panel>
              </div>
            </Sidebar>
          }

          {entity === 'purchase-order' &&
            (window.App.urlVars().create === 'purchaseorder-supplier' ||
            window.App.urlVars().update === 'purchaseorder-supplier') && (
            <Sidebar
              position="left"
              showCloseIcon={false}
              visible={
                window.App.urlVars().create === 'purchaseorder-supplier' ||
                window.App.urlVars().update === 'purchaseorder-supplier'
              }
              closeOnEscape={true}
              style={{
                width: window.App.urlVars().purchaseorderSupplierId ? '98%' : '780px'
              }}
              onHide={() => {
                history.push('/procurement/purchase-order/read/' + id);
              }}
            >
              <div className="PageContent p-px-1 p-py-3 p-mx-auto">
                <div className="p-grid">
                  <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left">
                    <h2 className="p-m-0 p-p-0 text-primary p-d-inline">
                      {t('order')}&nbsp;
                      {window.App.urlVars().purchaseorderSupplierId
                        ? t('updateSuffix')
                        : t('createSuffix')}
                    </h2>
                  </div>
                  <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right">
                    <a
                      onClick={() => {
                        history.push('/procurement/purchase-order/read/' + id);
                      }}
                      className="p-button  p-button-secondary p-ml-2"
                    >
                      <i className="pi pi-arrow-left" />
                      &nbsp;
                      {t('back')}
                    </a>
                  </div>
                </div>
                <Panel>
                  {(action === 'create' || action === 'update' || action === 'read') && (
                    <>
                      <PurchaseorderSupplierFormComponent
                        purchaseOrderId={id}
                        purchaseOrderSupplierId={window.App.urlVars().purchaseorderSupplierId}
                        backlink={'/procurement/purchase-order/read/' + id}
                        purchaseOrderStatus={purchaseorder.status}
                      />
                      {window.App.urlVars().purchaseorderSupplierId && (
                        <PurchaseorderSupplierDndComponent
                          purchaseOrderId={id}
                          purchaseOrderSupplierId={window.App.urlVars().purchaseorderSupplierId}
                          purchaseOrderStatus={purchaseorder.status}
                        />
                      )}
                    </>
                  )}
                </Panel>
              </div>
            </Sidebar>
          )}
          {entity === 'purchase-order' && window.App.urlVars().read === 'purchaseorder-supplier' && (
            <Sidebar
              position="left"
              showCloseIcon={false}
              visible={window.App.urlVars().read === 'purchaseorder-supplier'}
              closeOnEscape={true}
              style={{ width: '98%' }}
              onHide={() => {
                history.push('/procurement/purchase-order/read/' + id);
              }}
            >
              <div className="PageContent p-px-1 p-py-3 p-mx-auto">
                <div className="p-grid">
                  <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left">
                    <h2 className="p-m-0 p-p-0 text-primary p-d-inline">
                      {t('supplierOrderShow')}
                    </h2>
                  </div>
                  <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right">
                    <a
                      onClick={() => {
                        history.push('/procurement/purchase-order/read/' + id);
                      }}
                      className="p-button  p-button-secondary p-ml-2"
                    >
                      <i className="pi pi-arrow-left" />
                      &nbsp;{t('back')}
                    </a>
                  </div>
                </div>
                <Panel>
                  <PurchaseorderSupplierDndComponent
                    purchaseOrderId={id}
                    purchaseOrderSupplierId={window.App.urlVars().purchaseorderSupplierId}
                    mode="read"
                    purchaseOrderStatus={purchaseorder.status}
                  />
                </Panel>
              </div>
            </Sidebar>
          )}
          {entity === 'purchase-order' && (window.App.urlVars().create === 'inventorydocument' || window.App.urlVars().update === 'inventorydocument' || window.App.urlVars().read === 'inventorydocument') &&
            <Sidebar position="left"
                     showCloseIcon={false}
                     visible={window.App.urlVars().create === 'inventorydocument' || window.App.urlVars().update === 'inventorydocument' || window.App.urlVars().read === 'inventorydocument'}
                     closeOnEscape={true}
                     style={{width: '98%'}}
                     onHide={() => {
                       if (action === 'create' || action === 'update' || action === 'read') {
                         history.push(-1)
                       }
                     }}>
              <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {(id ?? window.App.urlVars().inventoryDocumentId) ? t('deliveryNoteRegistration') : t('deliveryNoteCreate')}
                    </h2>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                    <a onClick={() => {
                      if (action === 'create' || action === 'update' || action === 'read') {
                        history.push(-1)
                      }
                    }}
                       className={"p-button  p-button-secondary p-ml-2"}>
                      <i className={"pi pi-arrow-left"}></i>
                      &nbsp;
                      {t('back')}
                    </a>
                  </div>
                </div>
                <Panel>
                  {((action === 'create' || action === 'update' || action === 'read') && !window.App.urlVars().read) &&
                    // <InventorydocumentFormComponent entity={'transfer-supplier'}
                    //                                 backlink={'/procurement/' + entity + '/' + action + '/' + id}/>
                    <PurchaseorderInventorydocumentFormComponent entity={'transfer-supplier'}
                                                                 backlink={'/procurement/' + entity + '/' + action + '/' + id}
                                                                 purchaseOrderStatus={purchaseorder.status} />
                  }
                  {window.App.urlVars().read === 'inventorydocument' &&
                  <>
                    <InventorydocumentShowComponent entity={'transfer-supplier'}
                                                    backlink={'/procurement/' + entity + '/' + action + '/' + id}/>
                    <TabView activeIndex={activeTabIndex} onTabChange={(e) => setActiveTabIndex(e.index)}>
                      <TabPanel header={t('tabPreview')} leftIcon="pi pi-eye">
                        <InventorydocumentShowComponent
                          entity="transfer-supplier"
                          view="preview"
                          backlink={'/procurement/' + entity + '/' + action + '/' + id}
                        />
                      </TabPanel>
                      <TabPanel header={t('tabDocumentImage')} leftIcon="pi pi-file">
                        <InventorydocumentShowComponent
                          entity="transfer-supplier"
                          view="file"
                          backlink={'/procurement/' + entity + '/' + action + '/' + id}
                        />
                      </TabPanel>
                    </TabView>
                  </>
                  }
                </Panel>
              </div>
            </Sidebar>
          }
          {entity === 'purchase-order' && window.App.urlVars().copy === 'inventorydocument-receipt' && (
            <Sidebar
              position="left"
              showCloseIcon={false}
              visible={window.App.urlVars().copy === 'inventorydocument-receipt'}
              closeOnEscape={true}
              style={{ width: '98%' }}
              onHide={() => {
                const basePath = '/procurement/' + entity + '/' + action + '/' + id;
                const vars = window.App.urlVars();
                const newVars = { ...vars };
                delete newVars.copy;
                delete newVars.inventoryDocumentId;

                let query = '?';
                Object.entries(newVars).forEach(([key, value]) => {
                  if (value !== undefined && value !== null && value !== '') {
                    query += key + '=' + value + '&';
                  }
                });

                history.push(basePath + (query === '?' ? '' : query));
              }}
            >
              <div className="PageContent p-px-1 p-py-3 p-mx-auto">
                <div className="p-grid">
                  <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left">
                    <h2 className="p-m-0 p-p-0 text-primary p-d-inline">
                      {t('deliveryNoteRelatedReceipts')}
                    </h2>
                  </div>
                  <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right">
                    <a
                      onClick={() => {
                        const basePath = '/procurement/' + entity + '/' + action + '/' + id;
                        const vars = window.App.urlVars();
                        const newVars = { ...vars };
                        delete newVars.copy;
                        delete newVars.inventoryDocumentId;

                        let query = '?';
                        Object.entries(newVars).forEach(([key, value]) => {
                          if (value !== undefined && value !== null && value !== '') {
                            query += key + '=' + value + '&';
                          }
                        });

                        history.push(basePath + (query === '?' ? '' : query));
                      }}
                      className="p-button  p-button-secondary p-ml-2"
                    >
                      <i className="pi pi-arrow-left"></i>
                      &nbsp;
                      {t('back')}
                    </a>
                  </div>
                </div>
                <Panel>
                  <PurchaseorderInventorydocumentCopyListComponent
                    inventoryDocumentId={window.App.urlVars().inventoryDocumentId}
                  />
                </Panel>
              </div>
            </Sidebar>
          )}

          {entity === 'purchase-order' && window.App.urlVars().copy === 'inventorydocument-receipt' && window.App.urlVars().copyMode === 'dnd' && (
            <Sidebar
              position="left"
              showCloseIcon={false}
              visible
              closeOnEscape
              style={{ width: '1880px' }}
              onHide={() => {
                // history.push(
                //   '/procurement/purchase-order/read/' +
                //     id +
                //     '?copy=inventorydocument-receipt&inventoryDocumentId=' +
                //     window.App.urlVars().inventoryDocumentId
                // );
                history.goBack();
              }}
            >
              <div className="PageContent p-px-1 p-py-3 p-mx-auto">
                <div className="p-grid">
                  <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left">
                    <h2 className="p-m-0 p-p-0 text-primary p-d-inline">
                      {t('receiptAssignment')}
                    </h2>
                  </div>
                  <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right">
                     <Button
                        icon="pi pi-lock"
                        className="p-button p-button-success p-ml-2"
                        label={t('linkItems')}
                        style={{ flex: '0 0 auto', whiteSpace: 'nowrap', maxWidth: 'none' }}
                        onClick={() => {
                          apiCall('put', '/api/v2/inventory-document/transfer-supplier/' + window.App.urlVars()?.inventoryDocumentId  + 
                          '/match/' + window.App.urlVars()?.receiptId)
                            .then(response => {
                              const matchedCount = response?.data?.matchedCount ?? response?.data?.data?.matchedCount ?? 0;
                              if (matchedCount > 0) {
                                window.App.toastShow('success', `Sikeresen összekapcsolva ${matchedCount} tétel.`);
                              } else {
                                window.App.toastShow('info', 'Nem történt összekapcsolás');
                              }
                              window.App.setState?.({
                                rerenderPurchaseorderInventorydocumentCopyDnd: Math.random()
                              });
                            })
                            .catch(error => {
                              window.App.toastShow('error', t('error'), error?.response?.data?.message || error.toString(), '', error.response);
                            });
                        }}
                      />
                    <a
                      onClick={() => {
                        history.goBack();
                      }}
                      className="p-button  p-button-secondary p-ml-2"
                    >
                      <i className="pi pi-arrow-left"></i>
                      &nbsp;
                      {t('back')}
                    </a>
                  </div>
                </div>
                <Panel>
                  <PurchaseorderInventorydocumentCopyDndComponent />
                </Panel>
              </div>
            </Sidebar>
          )}

          {entity === 'purchase-order' && (window.App.urlVars().create === 'inventorygrn' || window.App.urlVars().update === 'inventorygrn') &&
            <Sidebar position="left"
                     showCloseIcon={false}
                     visible={window.App.urlVars().create === 'inventorygrn' || window.App.urlVars().update === 'inventorygrn'}
                     closeOnEscape={true}
                     style={{width: '98%'}}
                     onHide={() => {
                       if (action === 'create' || action === 'update' || action === 'read') {
                         history.push('/procurement/' + entity + '/' + action + '/' + id)
                       }
                     }}>
              <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {window.App.urlVars().inventorygrnId ? t('goodsReceiptUpdate') : t('goodsReceiptCreate')}
                    </h2>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                    <a onClick={() => {
                      if (action === 'create' || action === 'update' || action === 'read') {
                        history.push('/procurement/' + entity + '/' + action + '/' + id)
                      }
                    }}
                       className={"p-button  p-button-secondary p-ml-2"}>
                      <i className={"pi pi-arrow-left"}></i>
                      &nbsp;
                      {t('back')}
                    </a>
                  </div>
                </div>
                <Panel>
                  {(action === 'create' || action === 'update' || action === 'read') &&
                    <InventorygrnFormComponent backlink={'/procurement/' + entity + '/' + action + '/' + id}/>
                  }
                </Panel>
              </div>
            </Sidebar>
          }
          {entity === 'purchase-order' && (window.App.urlVars().read === 'inventorygrn') &&
            <Sidebar position="left"
                     showCloseIcon={false}
                     visible={window.App.urlVars().read === 'inventorygrn'}
                     closeOnEscape={true}
                     style={{width: '980px'}}
                     onHide={() => {
                       if (action === 'create' || action === 'update' || action === 'read') {
                         history.push('/procurement/' + entity + '/' + action + '/' + id)
                       }
                     }}>
              <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {t('goodsReceiptShow')}
                    </h2>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                    <a onClick={() => {
                      if (action === 'create' || action === 'update' || action === 'read') {
                        history.push('/procurement/' + entity + '/' + action + '/' + id)
                      }
                    }}
                       className={"p-button  p-button-secondary p-ml-2"}>
                      <i className={"pi pi-arrow-left"}></i>
                      &nbsp;
                      {t('back')}
                    </a>
                  </div>
                </div>
                <Panel>
                  <InventorygrnShowComponent backlink={'/procurement/' + entity + '/' + action + '/' + id}/>
                </Panel>
              </div>
            </Sidebar>
          }
          {window.App.urlVars().create === 'import' &&
            <Sidebar position="left"
                     showCloseIcon={false}
                     visible={window.App.urlVars().create === 'import'}
                     closeOnEscape={true}
                     style={{width: '780px'}}
                     onHide={() => {
                       history.push(-1)
                     }}>
              <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {id ? t('importUpdate') : t('importCreateAction')}
                    </h2>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>
                  </span>
                    <a onClick={() => {
                      history.push(-1)
                    }}
                       className={"p-button  p-button-secondary p-ml-2"}>
                      <i className={"pi pi-arrow-left"}></i>
                      &nbsp;
                      {t('back')}
                    </a>
                  </div>
                </div>
                <Panel>
                  <ImportFormComponent backlink={'/procurement/' + entity + '/' + action + '/' + id }/>
                </Panel>
              </div>
            </Sidebar>
          }

          <Sidebar position="bottom"
                   visible={window.App.urlVars().search === 'material'}
                   closeOnEscape={true}
                   style={{width: '100%', height: '80%'}}
                   onHide={() => {
                     history.push('/procurement/' + entity + '/' + action + '/' + id)
                   }}>
            <div className={"p-grid p-mt-3"}>
              <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                <h3 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                  {t('productSearch')}
                </h3>
              </div>
              <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>

              </div>
            </div>
            <Panel>
              <MaterialListComponent view={"search"} backlink={'/procurement/' + entity + '/' + action + '/' + id}/>
            </Panel>
          </Sidebar>

          <Sidebar
            position="left"
            visible={!!window.App.state?.sidebarReceiptFromInventory}
            closeOnEscape={true}
            style={{ width: '980px' }}
            onHide={() => {
              window.App.setState({
                sidebarReceiptFromInventory: false,
              });
              setTimeout(() => {
                window.App.setState({
                  receiptFromInventoryInitialValues: null,
                  props: null,
                });
              }, 0);
            }}
          >
            <div className="PageContent p-px-1 p-py-3 p-mx-auto">
              <Panel>
                {window.App.state?.receiptFromInventoryInitialValues?.id ? (
                  <ReceiptShowComponent
                    initialValues={window.App.state.receiptFromInventoryInitialValues}
                    external={true}
                  />
                ) : null}
              </Panel>
            </div>
          </Sidebar>


          
          {/* purchase-order partner search (Partner kiválasztás) */}
          <Sidebar
            position="bottom"
            visible={window.App.urlVars().search === 'partner'}
            closeOnEscape
            style={{ width: '100%', height: '80%' }}
            onHide={() => {
              const basePath =
                '/procurement/' +
                entity + '/' +
                action +
                (id && id !== 'undefined' ? '/' + id : '');
              const vars = window.App.urlVars();
              const newVars = { ...vars };
              delete newVars.search;

              let query = '?';
              Object.entries(newVars).forEach(([key, value]) => {
                if (value !== undefined && value !== null && value !== '') {
                  query += key + '=' + value + '&';
                }
              });
              history.push(basePath + query);
            }}
          >
            <div className="p-grid p-mt-3">
              <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left">
                <h3 className="p-m-0 p-p-0 text-primary p-d-inline">{t('partnerSearch')}</h3>
              </div>
              <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"></div>
            </div>
            <Panel>
              <PartnerListComponent
                view="search"
                backlink={
                  '/procurement/' +
                  entity + '/' +
                  action +
                  (id && id !== 'undefined' ? '/' + id : '')
                }
              />
            </Panel>
          </Sidebar>

          {/* purchase-request/create employee search (Igénylő kiválasztás) */}
          <Sidebar
            position="bottom"
            visible={window.App.urlVars().search === 'employee'}
            closeOnEscape={true}
            style={{width: '100%', height: '80%'}}
            onHide={() => {
              const basePath =
                '/procurement/' +
                entity + '/' +
                action +
                (id && id !== 'undefined' ? '/' + id : '');
              const vars = window.App.urlVars();
              const newVars = {...vars};
              delete newVars.search;

              let query = '?';
              Object.entries(newVars).forEach(([key, value]) => {
                if (value !== undefined && value !== null) {
                  query += key + '=' + value + '&';
                }
              });

              history.push(basePath + query);
            }}
          >
            <div className="p-grid p-mt-3">
              <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left">
                <h3 className="p-m-0 p-p-0 text-primary p-d-inline">
                  {t('requesterSearch')}
                </h3>
              </div>
              <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right">
              </div>
            </div>
            <Panel>
              <EmployeeListComponent
                view={"search"}
                backlink={
                  '/procurement/' +
                  entity + '/' +
                  action +
                  (id && id !== 'undefined' ? '/' + id : '')
                }
              />
            </Panel>
          </Sidebar>

          {/* purchase-request/create project search (Projekt kiválasztás) */}
          <Sidebar
            position="bottom"
            visible={window.App.urlVars().search === 'project'}
            closeOnEscape={true}
            style={{width: '100%', height: '80%'}}
            onHide={() => {
              const basePath =
                '/procurement/' +
                entity + '/' +
                action +
                (id && id !== 'undefined' ? '/' + id : '');

              history.push(basePath);
            }}
          >
            <div className="p-grid p-mt-3">
              <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left">
                <h3 className="p-m-0 p-p-0 text-primary p-d-inline">
                  {t('projectSearch')}
                </h3>
              </div>
              <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right">
              </div>
            </div>
            <Panel>
              <ProjectListComponent
                view={"search"}
                backlink={
                  '/procurement/' +
                  entity + '/' +
                  action +
                  (id && id !== 'undefined' ? '/' + id : '')
                }
              />
            </Panel>
          </Sidebar>

        </>
      ) : (
        <p className={"p-text-center p-my-5 p-py-5"}>
          <i className={"pi pi-exclamation-circle p-d-block p-mb-5"} style={{'fontSize': '5em'}}></i>
          <span className={"p-text-bold p-d-block "}>Ehhez a modulhoz sajnos nem rendelkezel hozzáféréssel.</span>
          Amennyiben további információra van szükséged írj emailt a {process.env.REACT_APP_DEVOPS_CONTACT} címre.
          {process.env.REACT_APP_SUBSCRIPTIONS === 'enabled' &&
            <span className={"p-text-bold p-d-block p-mt-5"}>
                       <a className={"p-button p-button-warning"}
                          onClick={() => {
                            window.location.replace('/#/subscriptions');
                            window.App.forceUpdate()
                          }}
                       >
                         <i className={"pi pi-building"}></i>&nbsp;Előfizetői fiók áttekintése
                       </a>
                   </span>
          }
        </p>
      )
      }
    </div>
  )
}
export default withTranslation('common')(InventoryPage);
